import infoService from 'leo-services/infoService';

export default {
  name: 'common',
  state: {
    formData: {
      companyList: [],
      shifenCompanyList: [], // 室分公司列表
      departmentList: [],
    },
    // formValues: initFormValues,
    auditTablePageSize: localStorage.getItem('auditTablePageSize') || 15,
  },
  effects: (dispatch) => ({
    async getInspectionCompany() {
      const result = await infoService.getInspectionCompany(0); // 0=全部
      if (result) {
        this.setFormData({ companyList: [{ id: null, name: '全部' }, ...result] });
      }
    },
    // 获取室分公司列表
    async getShifenCompanyList() {
      const result = await infoService.getInspectionCompany(2); // 2=室分
      if (result) {
        this.setFormData({ shifenCompanyList: result });
      }
    },
    async getDepartmentList(id) {
      const result = await infoService.getInspectionDepartmentListByCompanyId(id);
      if (result) {
        this.setFormData({ departmentList: [{ id: null, name: '全部' }, ...result] });
      }
    },
  }),
  reducers: {
    setFormData(state, payload) {
      for (const [key, value] of Object.entries(payload)) {
        state.formData[key] = value;
      }
      return state;
    },
    changePageSize(state, size) {
      localStorage.setItem('auditTablePageSize', size);
      state.auditTablePageSize = size;
      return state;
    },
  },
};
